export const CATEGORIES = [
  { id: "huellen", name: "Handyhüllen", icon: "shield" },
  { id: "displayschutz", name: "Displayschutz", icon: "shield-check" },
  { id: "ladekabel", name: "Ladekabel", icon: "cable" },
  { id: "ladegeraete", name: "Ladegeräte", icon: "plug-zap" },
  { id: "powerbanks", name: "Powerbanks", icon: "battery-charging" },
  { id: "kopfhoerer", name: "Kopfhörer", icon: "headphones" },
  { id: "smartwatches", name: "Smartwatches", icon: "watch" },
  { id: "tablets", name: "Tablets", icon: "tablet" },
  { id: "tastentelefone", name: "Tastentelefone", icon: "phone" },
  { id: "kids", name: "Kids", icon: "baby" },
  { id: "original-zubehoer", name: "Original Zubehör", icon: "sparkles" },
  { id: "apple-original", name: "Apple Original", icon: "apple" },
  { id: "samsung-original", name: "Samsung Original", icon: "smartphone" },
  { id: "sonstige", name: "Sonstige", icon: "package" },
];

export const COLOR_PALETTE = [
  { id: "schwarz", name: "Schwarz", hex: "#0A0A0B" },
  { id: "weiss", name: "Weiß", hex: "#F5F5F5" },
  { id: "grau", name: "Grau", hex: "#6B7280" },
  { id: "silber", name: "Silber", hex: "#C0C0C0" },
  { id: "gold", name: "Gold", hex: "#D4AF37" },
  { id: "rose", name: "Roségold", hex: "#E8B4A0" },
  { id: "beige", name: "Beige", hex: "#E5D8C0" },
  { id: "carbon", name: "Carbon", hex: "#1A1A1F" },
  { id: "babyblau", name: "Babyblau", hex: "#A6D1F2" },
  { id: "blau", name: "Blau", hex: "#1E40AF" },
  { id: "rot", name: "Rot", hex: "#DC1928" },
  { id: "gruen", name: "Grün", hex: "#15803D" },
  { id: "pink", name: "Pink", hex: "#EC4899" },
  { id: "lila", name: "Lila", hex: "#7C3AED" },
  { id: "gelb", name: "Gelb", hex: "#EAB308" },
  { id: "orange", name: "Orange", hex: "#F97316" },
  { id: "braun", name: "Braun", hex: "#78350F" },
  { id: "transparent", name: "Transparent", hex: "transparent" },
];

export const TRUST_BADGES = [
  { icon: "zap", title: "Express Reparatur", desc: "Oft in 60 Min." },
  { icon: "shield-check", title: "Garantie", desc: "6 Monate" },
  { icon: "gem", title: "Hochwertige Teile", desc: "Original & OEM-Qualität" },
  { icon: "handshake", title: "Partnerbetrieb", desc: "A1 & MTel Austria" },
];

export const AVAILABILITY_OPTIONS = [
  { id: "available",   label: "Verfügbar",      color: "emerald", desc: "Auf Lager · sofort bestellbar" },
  { id: "sold_out",    label: "Ausverkauft",    color: "amber",   desc: "Im Shop sichtbar, aber nicht bestellbar" },
  { id: "unavailable", label: "Nicht verfügbar", color: "zinc",   desc: "Im Shop ausgeblendet" },
];

export const STATUS_LABELS = {
  new: { label: "Neu", color: "bg-blue-100 text-blue-700 border-blue-200" },
  in_progress: { label: "In Bearbeitung", color: "bg-amber-100 text-amber-700 border-amber-200" },
  waiting_parts: { label: "Wartet auf Teile", color: "bg-purple-100 text-purple-700 border-purple-200" },
  ready_pickup: { label: "Abholbereit", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  completed: { label: "Abgeschlossen", color: "bg-zinc-100 text-zinc-700 border-zinc-200" },
};

export const STATUS_FLOW = ["new", "in_progress", "waiting_parts", "ready_pickup", "completed"];
